$(document)
  .off('click', "[data-behaviour='invoice-content-license-details']")
  .on(
    'click',
    "[data-behaviour='invoice-content-license-details']",
    (event) => {
      const dataset = event.target.dataset
      window.modalCitizen.openModal('invoice-content-license-details-modal', {
        licenses: JSON.parse(dataset.licenses),
      })
    }
  )
